import styled from '@emotion/styled'
import React from 'react'
import { IconPremium } from '../../../../icons'
import { breakpoint, calcRem, fonts } from '../../../../__styling'

export const StyledBreachWallTermsButtonContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: calcRem(8),

    [breakpoint('xs')]: {
        flexDirection: 'row',
    },
})

export const StyledBreachWallTermsButton = styled('button')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: calcRem(16),
    justifyContent: 'center',
    padding: calcRem(12, 24),

    border: 'none',
    borderRadius: calcRem(2),
    background: '#FFF',
    boxShadow: `0 4px 20px 0 rgba(0,0,0, 0.11)`,

    cursor: 'pointer',
}))

export const StyledBreachWallTermsButtonText = styled('p')(({ theme }) => ({
    margin: 0,
    paddingBottom: calcRem(2),
    display: 'flex',

    color: theme.colors.brand,
    fontFamily: theme.fonts.sansSerif,
    fontSize: calcRem(18),
    fontWeight: 500,
    lineHeight: calcRem(20),
}))

export const StyledTermButtonRightChevron = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="9"
        height="16"
        viewBox="0 0 9 16"
        fill="none"
    >
        <path
            d="M0.999999 1L8 8L1 15"
            stroke="#043DE2"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const StyledBreachWallSupportContainer = styled('div')({
    padding: calcRem(0, 20),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: calcRem(10),

    [breakpoint('xs')]: {
        padding: calcRem(0, 74),
    },
})

export const StyledBreachWallTermsText = styled('p')(({ theme }) => ({
    margin: 0,
    color: '#535556',
    textAlign: 'center',

    fontFamily: theme.fonts.serif,
    fontSize: calcRem(16),
    fontWeight: 400,
    lineHeight: calcRem(24),

    a: {
        color: '#535556',

        textDecorationLine: 'underline',
        textDecorationStyle: 'solid',
        textDecorationSkipInk: 'none',
        textDecorationThickness: 'auto',
        textUnderlineOffset: 'auto',
        textUnderlinePosition: 'from-font',
    },
}))

export const StyledBreachWallHelpText = styled('p')(({ theme }) => ({
    margin: 0,
    color: '#535556',
    textAlign: 'center',

    fontFamily: theme.fonts.sansSerif,
    fontSize: calcRem(16),
    fontWeight: 500,
    lineHeight: calcRem(24),
}))

export const StyledMessageBannerContainer = styled('div')({
    display: 'flex',
    gap: calcRem(8),
})

export const StyledIconPremium = styled(IconPremium)({
    width: calcRem(24),
    height: calcRem(24),
    margin: 0,
})
export const StyledPremiumText = styled('p')({
    fontFamily: fonts.thewest.sansSerif,
    fontSize: calcRem(14),
    fontWeight: 400,
    lineHeight: calcRem(16),
    color: '#2B2D2E',

    margin: 0,
    alignContent: 'center',

    a: {
        textDecoration: 'underline',
        cursor: 'pointer',
        color: '#2B2D2E',
    },
})
